<syn-avatar *ngIf="!user?.deletedAt"
    [size]="size"
    [tooltip]="tooltip ? title : ''"
    [link]="clickable ? link : undefined"
    [text]="text"
    [caption]="caption"
    [avatarIco]="avatarIco"
    class="my-avatar"
    [backgroundColor]="backgroundColor"
    [iconColor]="iconColor"
    [textColor]="textColor"
></syn-avatar>
<syn-avatar *ngIf="user?.deletedAt"
    [size]="size"
    [tooltip]="tooltip ? title : ''"
    [link]="clickable ? link : undefined"
    [text]="text"
    [caption]="caption"
    [matIco]="avatarIco"
    class="my-avatar"
    [backgroundColor]="textColor"
    [textColor]="textColor"
></syn-avatar>
